module.exports = "/_next/static/images/5407c867bef924991448119c2e88527b-notaxes@0.75x.jpg";